<template>
  <div class="h-100">
    <b-overlay :blur="null" :show="loading" class="h-100" opacity="0">
      <transition mode="out-in" name="fadeDownShort">
        <div v-if="!loading">
          <component :is="type + 'View'" v-if="type" :data="data" />
        </div>
      </transition>
    </b-overlay>
  </div>
</template>
<script>
import PowerView from './power/View'
import GasView from './gas/View'
import WaterView from './water/View'
import HeatView from './heat/View'
import { mapState } from 'vuex'

export default {
  components: {
    PowerView,
    GasView,
    WaterView,
    HeatView,
  },
  computed: {
    ...mapState({
      data: (state) => state.energetic.current.data,
      loading: (state) => state.energetic.current.loading,
    }),
    type() {
      return this.data._type.const.toLowerCase()
    },
  },
}
</script>
